import GdModalConfirm from "@/components/GdModalConfirm";
import HBIcon from "@/components/HBIcon";
import { cancelMerge } from "@/services";
import { Avatar, Button } from "antd";
import classNames from "classnames";
import styles from "./index.module.less";

/**
 * 因某些异常导致合并处于中间态， 用户可取消合并与继续合并
 */
export default function GdMergeInterimState({ checkResult, onGoOn, onCancel }) {
  return (
    <div className={styles.interim}>
      <div className={styles.card}>
        <div className={styles.title}>你上次未完成账号升级流程，是否继续？</div>
        <div className={styles.avatar}>
          <Avatar
            shape="circle"
            size={108}
            src={
              checkResult?.avatar?.url ||
              "https://gd-hbimg.huaban.com/654953460733026a7ef6e101404055627ad51784a95c-B6OFs4"
            }
          />
        </div>
        <div>{checkResult?.user_name}</div>
        <div className={styles.operation}>
          <Button
            className={classNames([styles.button, styles.primary])}
            onClick={onGoOn}
          >
            继续合并
          </Button>
          <a
            className={classNames([styles.button, "gd-blue-text-button"])}
            onClick={async () => {
              GdModalConfirm.open({
                closable: false,
                className: styles.confirm,
                cancelText: "暂不取消",
                okText: "确定",
                async onOk() {
                  await cancelMerge();
                  onCancel?.();
                },
                content: (
                  <div className={styles.content}>
                    <HBIcon className={styles.icon} type="ic_Warning" />
                    <div className={styles.text}>
                      账号绑定关系将解除，后续可重新绑定
                    </div>
                  </div>
                ),
              });
            }}
          >
            取消合并
          </a>
        </div>
      </div>
    </div>
  );
}
